import { getIntrinsicElementProps, slot } from "@fluentui/react-utilities";
import * as React from 'react';

import { DetailsPageProps, DetailsPageState } from "./DetailsPage.types";

export function useDetailsPageState_unstable(props: DetailsPageProps, ref: React.Ref<HTMLElement>): DetailsPageState {
  const {
    description,
    heading,
  } = props;
  const root = slot.always(
    getIntrinsicElementProps('main', {
      ...props,
      ref
    }),
    { elementType: 'main' });
  const headingShorthand = slot.always(heading, { elementType: 'h2' });
  const descriptionShorthand = slot.always(description, { elementType: 'summary' });

  return {
    components: {
      root: 'main',
      heading: 'h2',
      description: 'summary',
    },
    root: root,
    heading: headingShorthand,
    description: descriptionShorthand,
  }
}
